import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import * as popupConstants from '@bingads-webui-campaign-legacy/alerts-popup/constants/alertPopupConstants';
import accountAlertsPopupTemplate from '@bingads-webui-campaign-legacy/alerts-popup/template/accountAlertsPopup.pug';
import managerAccountsPopupTemplate from '@bingads-webui-campaign-legacy/alerts-popup/template/managerAccountsPopup.pug';
import pageContext from '@bingads-webui-static-legacy/page-context';
import config from '@bingads-webui-component-legacy/config/index';
import urlUtil from '@bingads-webui-component-legacy/http/util/url';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/alerts-popup');

export default class AlertsPopup extends Backbone.View {
  static get popupId() {
    return popupConstants.popupId;
  }

  get events() {
    return {
      'click .closeimage': 'closePopup',
      'keydown .closeimage': 'closePopup',
    };
  }

  set accountId(aid) {
    this.aid = aid;
  }

  render() {
    const popupContent = this.getPopupContent(this.accountInactiveReasons);

    this.$el.html(popupContent);
    return this;
  }

  renderManagerAccountsContent() {
    const popupContent = this.getManagerAccountsPopupContent(this.manageraccounts);

    this.$el.html(popupContent);
    return this;
  }

  closePopup(e) {
    let shouldClose = true;

    if (e.keyCode && e.keyCode !== 13) {
      shouldClose = false;
    }

    if (shouldClose) {
      $.advertiser.hideLayer({
        target: document,
        data: {
          targetLayerId: popupConstants.popupId,
          namespace: popupConstants.popupId,
          callback: $.gridPopup.ResetImage,
        },
      });
    }
  }

  getManagerAccountsPopupContent(manageraccounts) {
    const popupContent = managerAccountsPopupTemplate({
      manageraccounts,
      i18n,
      popUpText: {
        remove: i18n.get('Remove'),
      },
      closeText: i18n.get('ModalPopup_BizLoc_Close'),
    });

    return popupContent;
  }

  getPopupContent(accountInactiveReasons) {
    const alerts = _.chain(accountInactiveReasons).map((reason) => {
      return {
        category: this.getAlertCategory(reason.Reason),
        description: this.getAlertDescription(reason.Reason),
        causes: this.getAlertCauses(reason.Causes),
        action: this.getAlertAction(reason.Reason),
        learnMore: this.getLearnMore(reason.Reason),
      };
    }).filter((alert) => {
      return alert.category && alert.description;
    }).value();

    const popupContent = accountAlertsPopupTemplate({
      alerts,
      popUpText: {
        remove: i18n.get('Remove'),
        learnMore: i18n.get('LearnMore'),
      },
      closeText: i18n.get('ModalPopup_BizLoc_Close'),
      isForVNext: this.isForVNext,
    });

    return popupContent;
  }

  getAlertCategory(reason) {
    if (popupConstants.alertReasonId[reason]) {
      const i18nPrefix = popupConstants.i18nPrefixes.alertCategoryPrefix;
      const reasonId = popupConstants.alertReasonId[reason];

      return i18n.get(`${i18nPrefix}_${reasonId}`);
    }
    return null;
  }

  getAlertDescription(reason) {
    const i18nPrefix = popupConstants.i18nPrefixes.alertDescriptionPrefix;

    return i18n.get(`${i18nPrefix}_${reason}`);
  }

  getAlertCauses(causes) {
    let causeExplinations = [];

    _.each(causes, (cause) => {
      const i18nPrefix = popupConstants.i18nPrefixes.alertReasonPrefix;
      const causeCodeId = popupConstants.accountInactiveCauseCode[cause];
      const causeExplination = i18n.get(`${i18nPrefix}_${causeCodeId}`);

      if (causeExplination) {
        causeExplinations.push(causeExplination);
      }
    });
    return causeExplinations;
  }

  getAlertAction(reason) {
    if (reason === 'Inactive' || reason === 'PausedDueToSystemIssue' || reason === 'Deleted') {
      return {
        linkText: this.getAlertActionText('InactivePaused'),
        url: (config.get('Permissions') || {}).IsRenderClientShellPageEnabled ? config.get('FooterSupportUrl') : pageContext.Footer.SupportUrl,
      };
    }

    if (!popupConstants.alertActionConfig[reason]) {
      return null;
    }

    const alertActionConfig = popupConstants.alertActionConfig[reason];
    const host = pageContext.RootUIUrl;
    const path = alertActionConfig.relativePath;
    const data = {
      aid: this.aid,
      cid: pageContext.CurrentCustomer.Id,
    };

    if (!_.isEmpty(alertActionConfig.params)) {
      _.extend(data, alertActionConfig.params);
    }

    const url = urlUtil.queryify(urlUtil.make('', { host, path }), { data });

    return {
      linkText: this.getAlertActionText(reason),
      url,
    };
  }

  getAlertActionText(reason) {
    const i18nPrefix = popupConstants.i18nPrefixes.alertActionPrefix;
    const alertActionText = i18n.get(`${i18nPrefix}_${reason}`);

    return alertActionText.replace(/\{\d{1}\}/g, '');
  }

  getLearnMore(reason) {
    return popupConstants.learnMoreHelpIds[reason] || null;
  }
}
